import {
	SimpleCrud,
	SimpleCrudProps,
} from "src/components/SimpleCrud";
import { useBusiness } from "src/hooks/redux/useBusiness";
import {
	actualizarCargoEmpresa,
	agregarCargoEmpresa,
	quitarCargoEmpresa,
} from "src/redux/actions/businessActions";
import { useDispatch } from "src/redux/store";

export const BusinessCargosTab = () => {
	const dispatch = useDispatch();
	const { selectedBusiness, loading } = useBusiness();

	const handleSubmit: SimpleCrudProps["onCreateOrUpdate"] =
		(values, action, selected) => {
			if (action === "New") {
				dispatch(agregarCargoEmpresa(values));
			} else if (action === "Edit") {
				dispatch(
					actualizarCargoEmpresa(selected.Nombre, values)
				);
			}
		};

	const handleDelete: SimpleCrudProps["onDelete"] = (
		selected
	) => {
		dispatch(quitarCargoEmpresa(selected.Nombre));
	};

	// Transform the array to match CrudValue type
	const cargosArray = selectedBusiness?.Cargos 
		? [...new Set(selectedBusiness.Cargos)].map((cargo, index) => ({
			Nombre: typeof cargo === 'string' ? cargo : cargo.Nombre || '',
			Activado: true,
			index
		}))
		: [];

	return (
		<SimpleCrud
			key={"Cargos"}
			array={cargosArray}
			isLoading={loading}
			name={"Cargo"}
			onCreateOrUpdate={handleSubmit}
			onDelete={handleDelete}
		/>
	);
};
